import {useState} from "react";
import RangeSlider from "react-range-slider-input";
import {RangeFilterInterface} from "../../interfaces/core/RangeFilterInterface";
import {activeFilterCount, ChatFilterGroup, ChatFilterState, EMPTY_FILTER} from "./chatProductFilter";

// Значений свойства видно сразу; остальные — по «ещё»
const VISIBLE_VALUES = 8;

function toggle(values: string[], value: string): string[] {
    return values.includes(value) ? values.filter(item => item !== value) : [...values, value];
}

function Chips({values, selected, onToggle}: {
    values: {value: string, count?: number}[]
    selected: string[]
    onToggle: (value: string) => void
}) {
    const [all, setAll] = useState(false);
    const shown = all ? values : values.slice(0, VISIBLE_VALUES);

    return <div className="chat-filters__chips">
        {shown.map(({value, count}) => (
            <button key={value} type="button"
                    className={'chat-filters__chip' + (selected.includes(value) ? ' chat-filters__chip--active' : '')}
                    onClick={() => onToggle(value)}>
                {value}{count !== undefined && <span className="chat-filters__count">{count}</span>}
            </button>
        ))}
        {values.length > VISIBLE_VALUES && (
            <button type="button" className="chat-filters__more" onClick={() => setAll(!all)}>
                {all ? 'свернуть' : 'ещё ' + (values.length - VISIBLE_VALUES)}
            </button>
        )}
    </div>;
}

/**
 * Отбор в списке товаров ответа консультанта: цена, наличие, бренд, свойства из фильтров сайта.
 * Работает сразу, по уже загруженным товарам.
 */
export default function ChatProductFilters({filter, setFilter, groups, brands, withStock, priceRange}: {
    filter: ChatFilterState
    setFilter: (filter: ChatFilterState) => void
    groups: ChatFilterGroup[]
    brands: string[]
    withStock: boolean
    priceRange: RangeFilterInterface // цены товаров списка: границы слайдера
}) {
    const min = filter.priceMin ?? priceRange.min;
    const max = filter.priceMax ?? priceRange.max;

    return <div className="chat-filters">
        <div className="chat-filters__row">
            <div className="chat-filters__name">Цена, ₽</div>
            {/* .range — оранжевые ползунки, как у цены в каталоге (index.scss) */}
            {priceRange.max > priceRange.min && <div className="chat-filters__price range">
                <RangeSlider min={priceRange.min} max={priceRange.max} value={[min, max]}
                             onInput={([from, to]: number[]) => setFilter({
                                 ...filter,
                                 // На краю — без ограничения: товар без цены тогда не отсекается
                                 priceMin: from > priceRange.min ? from : null,
                                 priceMax: to < priceRange.max ? to : null,
                             })}/>
                <span className="chat-filters__price-value">{min.toLocaleString('ru-RU')} — {max.toLocaleString('ru-RU')}</span>
            </div>}
            {withStock && <label className="chat-filters__stock">
                <input type="checkbox" checked={filter.inStock} onChange={() => setFilter({...filter, inStock: !filter.inStock})}/>
                в наличии
            </label>}
        </div>
        {brands.length > 1 && <div className="chat-filters__row">
            <div className="chat-filters__name">Бренд</div>
            <Chips values={brands.map(value => ({value}))} selected={filter.brands}
                   onToggle={value => setFilter({...filter, brands: toggle(filter.brands, value)})}/>
        </div>}
        {groups.map(group => (
            <div key={group.id} className="chat-filters__row">
                <div className="chat-filters__name">{group.name}</div>
                <Chips values={group.values} selected={filter.properties[group.id] || []}
                       onToggle={value => setFilter({
                           ...filter,
                           properties: {...filter.properties, [group.id]: toggle(filter.properties[group.id] || [], value)},
                       })}/>
            </div>
        ))}
        <button type="button" className="btn gray chat-filters__reset" disabled={!activeFilterCount(filter)}
                onClick={() => setFilter(EMPTY_FILTER)}>Сбросить фильтры</button>
    </div>;
}
